import GenericDB from './generic-db';

export default class ChargeMastersDB extends GenericDB {
  constructor() {
    super('chargeMasters');
  }

  /**
   * CLINIC-SCOPED, and the inverse of its neighbor `serviceCodes-db`. Every document carries a bare
   * `clinic` field, which is the name the Firestore rules helpers read, and every read must constrain
   * on it — an unscoped read here reaches every clinic's charges. The catalog next door is the one
   * collection in this context with no scope at all; this one is scoped like `fundingSources`,
   * `treatmentServices` and `placesOfService`.
   *
   * EVERY DOCUMENT IS A SHEET — the charge master as it stood from one date onward — so a query
   * returns several rows per clinic and never one. Anything reading this collection has to resolve
   * which sheet applies to the date it cares about, or it will show several charge masters at once.
   * That resolution lives behind the context's published interface; nothing outside it queries here.
   *
   * NO HARD DELETE. A sheet that has taken effect is what past services were charged under, so
   * removing it rewrites history with nothing to show that it moved. Removal is the platform
   * soft-delete trio, and the rules permit it only for a sheet whose date has never arrived.
   */
}
